"use client";
import { createValidHtmlId } from "../../utilities/html/index.js";
import { useState } from "react";
import { tokens } from "@gnist/themes/tokens.css.js";
function useIconAndExtraTextWidth(hasIcon) {
  const iconWidth = hasIcon ? tokens.spacing.xl : "0px";
  const [textWidth, setTextWidth] = useState(0);
  const textRef = (node) => {
    var _a;
    return setTextWidth(((_a = node == null ? void 0 : node.getBoundingClientRect()) == null ? void 0 : _a.width) ?? 0);
  };
  return {
    textRef,
    width: `calc(${textWidth}px + ${iconWidth})`
  };
}
function isClickableIcon(icon) {
  return icon.onClick !== void 0;
}
function useInputFieldLogic({ label, density: _density = "default", validity = { type: "none" }, id = createValidHtmlId(label), leadingIcon, trailingIcon, disabled, density, className }) {
  const { textRef: prefixRef, width: preInputWidth } = useIconAndExtraTextWidth(!!leadingIcon);
  const { textRef: suffixRef, width: postInputWidth } = useIconAndExtraTextWidth(!!trailingIcon);
  const inputId = id;
  const labelId = `${id}-label`;
  const helperId = `${id}-helper`;
  return {
    wrapperProps: {
      preInputWidth,
      postInputWidth,
      validity,
      disabled,
      density,
      className
    },
    contentProps: {
      validity,
      prefixRef,
      suffixRef,
      inputId,
      labelId,
      helperId
    },
    commonInputProps: {
      ...validity.type === "error" && {
        "aria-invalid": true,
        "aria-errormessage": helperId
      },
      "aria-describedby": helperId,
      id,
      // Placeholder must be whitespace to ensure :placeholder-shown triggers when field is empty
      placeholder: " "
    }
  };
}
function useSelectInputLogic({ label, density: _density = "default", validity = { type: "none" }, id = createValidHtmlId(label), leadingIcon, disabled, density, className }) {
  const { width: preInputWidth } = useIconAndExtraTextWidth(!!leadingIcon);
  const { width: postInputWidth } = useIconAndExtraTextWidth(true);
  const inputId = id;
  const labelId = `${id}-label`;
  const helperId = `${id}-helper`;
  return {
    wrapperProps: {
      preInputWidth,
      postInputWidth,
      validity,
      disabled,
      density,
      className
    },
    contentProps: {
      validity,
      inputId,
      labelId,
      helperId
    },
    commonInputProps: {
      ...validity.type === "error" && {
        "aria-invalid": true,
        "aria-errormessage": helperId
      },
      "aria-describedby": helperId,
      id,
      // Placeholder must be whitespace to ensure :placeholder-shown triggers when field is empty
      placeholder: " "
    }
  };
}
function getInputFieldProps({ label, density, prefix, suffix, leadingIcon, trailingIcon, helperText, reserveSpaceForMessage, ...inputProps }) {
  return {
    extraInformation: {
      label,
      density,
      prefix,
      suffix,
      leadingIcon,
      trailingIcon,
      helperText,
      reserveSpaceForMessage
    },
    inputProps
  };
}
function getSelectInputProps({ label, density, leadingIcon, helperText, ...selectProps }) {
  return {
    extraInformation: {
      label,
      density,
      leadingIcon,
      helperText
    },
    selectProps
  };
}
export {
  getInputFieldProps,
  getSelectInputProps,
  isClickableIcon,
  useInputFieldLogic,
  useSelectInputLogic
};
